import { CSVProfile } from '../../types'
import { DoubleChartComponent } from '../charts/double-chart-component'
import { TRANSFORM_MILLI_TO_DATE } from '../commons/constants'

export class AFCompareSovByMentionType extends DoubleChartComponent {
 static config = {
  selector: 'afCompareSovByMentionType',
  controller: AFCompareSovByMentionType,
  bindings: DoubleChartComponent.config.bindings,
  template: DoubleChartComponent.config.template,
 }

 setProperties() {
  this.buildCSVExportProfile()
 }

 buildCSVExportProfile() {
  // ensure data is reset, otherwise array data will grow
  this.csvExportProfiles = []

  // TODO: the data for this widget need to be formatted in a consistent way to avoid the hack below.
  // *******************************
  let donutData = Object.assign({}, { all: this.namingUtils.returnData(this.vizData.extendedData.donut.data) })
  let donutExport: CSVProfile = {
   //cloning data to avoid mutation
   data: donutData,
   csvOptions: { title: this.properties.title, headers: ['Category', 'Count'] },
   transformationProfiles: [],
  }

  let vertBarData = Object.assign({}, { all: this.namingUtils.returnData(this.vizData.extendedData.vertBar.data) })
  let vertBarExport: CSVProfile = {
   data: vertBarData,
   csvOptions: { headers: ['Category', 'Count'], showTitle: false },
   transformationProfiles: [],
  }

  // exporting only one data set since both donut and vertical bar chart dare exacty the same.
//   this.csvExportProfiles.push(donutExport, vertBarExport)
  this.csvExportProfiles.push(donutExport)
 }
}
